export default {
  currentAccountId: undefined,
  userId: undefined,
  userName: undefined,
  email: undefined,
  role: undefined,
  accounts: [],
  currentAccountUsers: [],
  accountChannelsLoaded: undefined,
  currentAccountChannels: {
    /*
      [token]: {
        token: string,
        id: number,
        name: string,
        creatorName: string, // Creator Name
      }
    */
  },
  rolesLicense: {
    licenseId: undefined,
    licenseData: undefined,
    /*
      {
        [ROLE]: {
          current: number,
          limit: number
        }
      }
    */
  },
};
